import React from "react"
import { ThemeProvider, CssBaseline } from "@material-ui/core"
import { createMuiTheme } from "@material-ui/core/styles"
import AdminDashboardContainer from "../../containers/AdminContainer/AdminDashboardContainer"

function AdminDashboardPage() {
  const darkTheme = createMuiTheme({
    palette: {
      type: "dark",
    },
  })

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <AdminDashboardContainer />
    </ThemeProvider>
  )
}

export default AdminDashboardPage
